import uiEvents from 'events/ui';
import uiEnums from 'enums/ui';
import userSelectors from 'selectors/user';
import configSelectors from 'selectors/configuration';

export default function evaluateInitialCompositionStage(dispatch, getState) {
  const state = getState();
  const name = userSelectors.getName(state.user);
  const email = userSelectors.getEmail(state.user);
  const onboarding = configSelectors.getOnboarding(state.configuration);
  const configCompositionStage = onboarding.initialCompositionStage;

  if (state.user.hasOnboarded || !onboarding.enabled) {
    dispatch(uiEvents.updateCompositionStage(uiEnums.COMPOSITION_STAGES.MESSAGE));
  } else if (!name && !email) {
    dispatch(uiEvents.updateCompositionStage(configCompositionStage));
  } else if (!name) {
    dispatch(uiEvents.updateCompositionStage(uiEnums.COMPOSITION_STAGES.NAME));
  } else {
    dispatch(uiEvents.updateCompositionStage(uiEnums.COMPOSITION_STAGES.EMAIL));
  }
}
